import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '../../contexts/AuthContext';
import { formatApiErrorDetail } from '../../utils/axios';
import { Lock, User } from 'lucide-react';

export const AdminLogin = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    rememberMe: false
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await login(formData.username, formData.password, formData.rememberMe);
      toast.success('Login berhasil!');
      navigate('/admin/dashboard');
    } catch (error) {
      toast.error(formatApiErrorDetail(error.response?.data?.detail) || 'Login gagal');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4"
      style={{
        backgroundImage: 'url(https://images.unsplash.com/photo-1706675780107-7c43cc487928?crop=entropy&cs=srgb&fm=jpg&q=85)',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
      data-testid="admin-login-page"
    >
      <div className="absolute inset-0 bg-[#0B1020]/90" />
      
      <div className="relative z-10 w-full max-w-md">
        <div className="glass-card p-8">
          <div className="text-center mb-8">
            <div className="w-20 h-20 bg-gradient-to-br from-[#D90429] to-[#B00320] rounded-xl flex items-center justify-center mx-auto mb-4">
              <span className="text-white font-black text-4xl">ET</span>
            </div>
            <h1 className="text-3xl font-black text-white mb-2">Admin Login</h1>
            <p className="text-gray-400">Masuk ke dashboard admin</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-white font-semibold mb-2">
                <User className="inline-block mr-2 mb-1" size={18} />
                Username
              </label>
              <input
                type="text"
                value={formData.username}
                onChange={(e) => setFormData({ ...formData, username: e.target.value })}
                placeholder="Masukkan username"
                required
                data-testid="username-input"
              />
            </div>

            <div>
              <label className="block text-white font-semibold mb-2">
                <Lock className="inline-block mr-2 mb-1" size={18} />
                Password
              </label>
              <input
                type="password"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                placeholder="Masukkan password"
                required
                data-testid="password-input"
              />
            </div>

            <div className="flex items-center">
              <input
                type="checkbox"
                id="rememberMe"
                checked={formData.rememberMe}
                onChange={(e) => setFormData({ ...formData, rememberMe: e.target.checked })}
                className="mr-2"
              />
              <label htmlFor="rememberMe" className="text-gray-300 text-sm cursor-pointer">
                Ingat saya
              </label>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full"
              data-testid="login-btn"
            >
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>

          <div className="mt-6 text-center text-gray-400 text-sm">
            <p>EXTRA TIME v1.0</p>
          </div>
        </div>
      </div>
    </div>
  );
};